import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormGroup, Label, Input, UncontrolledTooltip } from 'reactstrap';
import { getVal } from '../../BaseFunctions';

class PrettyCheckboxFormik extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const {
			bsSize,
			checked,
			disabled,
			iconDanger,
			iconOff,
			iconOn,
			iconSuccess,
			id,
			isDisabled,
			isReadOnly,
			label,
			help,
			labelDanger,
			labelDefault,
			labelSuccess,
			name,
			prettyRadio,
			reverse,
			simpleSelection,
			strTitle,
			triState,
			prettyRadioValue,
			values,
		} = this.props;
		const helpID = help && `help-${id.toLowerCase().replace(/[_.]/g, '-')}`;

		return (
			<FormGroup check className="form-pretty-check input-pretty-checkbox">
				<Label check>
					{simpleSelection ? (
						<div className="pretty p-icon p-jelly p-has-focus" alt={strTitle} title={strTitle}>
							<Input
								checked={getVal(values, name || id) || checked || false}
								id={name || id}
								name={name || id}
								bsSize={bsSize}
								type="checkbox"
								onChange={this.props.handleChange}
								disabled={
									(values && values.readOnly) || isDisabled || isReadOnly || triState || disabled
								}
							/>
							<div className="state">
								<i className={`icon ${iconSuccess}`} />
								<label>
									{label || labelDefault || labelSuccess || labelDanger}
									{help && (
										<span>
											<i id={helpID} className="fas fa-info-circle" />
											<UncontrolledTooltip placement="left" target={helpID}>
												{help}
											</UncontrolledTooltip>
										</span>
									)}
								</label>
							</div>
						</div>
					) : prettyRadio ? (
						<div>
							<div className={`pretty p-icon ${iconOn && iconOff ? 'p-toggle' : 'p-round'} p-plain`}>
								<Input
									value={prettyRadioValue}
									checked={getVal(values, name || id) || checked || false}
									id={name || id}
									name={name || id}
									bsSize={bsSize}
									type="radio"
									onChange={this.props.handleChange}
									disabled={
										(values && values.readOnly) || isDisabled || isReadOnly || triState || disabled
									}
								/>
								<div className={`state ${iconOn && iconOff ? 'p-on' : 'p-success'}`}>
									<i className={`icon ${iconOn || 'far fa-circle'}`} />
									<label>
										{label || labelDefault}
										{help && (
											<span>
												<i id={helpID} className="fas fa-info-circle" />
												<UncontrolledTooltip placement="left" target={helpID}>
													{help}
												</UncontrolledTooltip>
											</span>
										)}
									</label>
								</div>
								{iconOn && iconOff && (
									<div className="state p-off">
										<i className={`icon ${iconOff}`} />
										<label>
											{label || labelDefault}
											{help && (
												<span>
													<i id={helpID} className="fas fa-info-circle" />
													<UncontrolledTooltip placement="left" target={helpID}>
														{help}
													</UncontrolledTooltip>
												</span>
											)}
										</label>
									</div>
								)}
							</div>
						</div>
					) : (
						<div className="pretty p-icon p-toggle p-plain" alt={strTitle} title={strTitle}>
							<Input
								checked={getVal(values, name || id) || checked || false}
								id={name || id}
								name={name || id}
								bsSize={bsSize}
								type="checkbox"
								onChange={this.props.handleChange}
								disabled={
									(values && values.readOnly) || isDisabled || isReadOnly || triState || disabled
								}
							/>
							<div className={`state ${isReadOnly ? '' : 'p-success-o'} ${reverse ? 'p-off' : 'p-on'}`}>
								<i className={`icon ${iconSuccess}`} />
								<label>
									{reverse ? labelDanger : labelSuccess}
									{help && (
										<span>
											<i id={helpID} className="fas fa-info-circle" />
											<UncontrolledTooltip placement="left" target={helpID}>
												{help}
											</UncontrolledTooltip>
										</span>
									)}
								</label>
							</div>
							<div
								className={`state ${triState ? '' : isReadOnly ? '' : 'p-danger-o'} ${
									reverse ? 'p-on' : 'p-off'
								}`}>
								<i className={`icon ${triState ? 'fas fa-minus' : iconDanger}`} />
								<label>
									{reverse ? labelSuccess : labelDanger}
									{help && (
										<span>
											<i id={helpID} className="fas fa-info-circle" />
											<UncontrolledTooltip placement="left" target={helpID}>
												{help}
											</UncontrolledTooltip>
										</span>
									)}
								</label>
							</div>
							<i className="for-transition" style={{ display: 'none' }} />
						</div>
					)}
				</Label>
			</FormGroup>
		);
	}
}

PrettyCheckboxFormik.propTypes = {
	bsSize: PropTypes.string,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	handleChange: PropTypes.func.isRequired,
	iconDanger: PropTypes.string,
	iconOff: PropTypes.string,
	iconOn: PropTypes.string,
	iconSuccess: PropTypes.string,
	id: PropTypes.string.isRequired,
	isDisabled: PropTypes.bool,
	isReadOnly: PropTypes.bool,
	label: PropTypes.string,
	help: PropTypes.string,
	labelDanger: PropTypes.string,
	labelDefault: PropTypes.string,
	labelSuccess: PropTypes.string,
	name: PropTypes.string,
	prettyRadio: PropTypes.bool,
	reverse: PropTypes.bool,
	simpleSelection: PropTypes.bool,
	strTitle: PropTypes.string,
	triState: PropTypes.bool,
	prettyRadioValue: PropTypes.string,
	values: PropTypes.object,
};

export { PrettyCheckboxFormik };
